import { frontendURL } from '../../../helper/URLHelper';

const SearchView = () => import('./pages/SearchView.vue');
const CompanyDetail = () => import('./pages/CompanyDetail.vue');

export const FLIP_LEADS_VIEW_PERMISSIONS = [
  'flip_leads_view',
  'flip_leads_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/leads'),
    name: 'flip_leads_search',
    meta: {
      permissions: ['administrator', ...FLIP_LEADS_VIEW_PERMISSIONS],
    },
    component: SearchView,
  },
  {
    path: frontendURL('accounts/:accountId/leads/:cnpj'),
    name: 'flip_leads_company',
    meta: {
      permissions: ['administrator', ...FLIP_LEADS_VIEW_PERMISSIONS],
    },
    component: CompanyDetail,
  },
];
